import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { DisplayGroupModel } from '../../../Layout/models/display-group.model';
import { AppearCondition, AutocompleteCustomOption } from '../../../Forms/components/Autocomplete/autocomplete-custom-option.model';
import { DisplayGroupsService } from '../../../Layout/services/display-groups.service';


/**
 * Prompt use to select a group.
 * Either;
 * - emits the DisplayGroupModel on dialogClose
 * - emits dialogCancelled event
 */
@Component({
    selector: 'agpr-group-selection-dialog',
    templateUrl: './group-selection-dialog.component.html',
    styleUrls: ['./group-selection-dialog.component.scss'],
    standalone: false
})
export class GroupSelectionDialogComponent extends AbstractDialogComponent {

    @Input() id: string = 'groupSelectionDialog';
    @Input() groupOptions$: Observable<DisplayGroupModel[]>;

    @Output() dialogCancelled = new EventEmitter<null>();

    selectedOption: DisplayGroupModel;

    readonly buttonStyle = ButtonTypesEnum;
    readonly autocompleteCustomOptions: AutocompleteCustomOption[] = [
        {
            label: 'Common.lhp.groupSelectionDialog.autocomplete.createGroup',
            clearOnSelect: false,
            appearCondition: AppearCondition.noExactMatchInSuggestions,
            action: (name: string) => this.createNewGroup(name)
        }
    ];

    constructor(
        public coreDialogService: CoreDialogService,
        private displayGroupsService: DisplayGroupsService
    ) {
        super(coreDialogService, 'GroupSelection');
    }


    createNewGroup(name: string) {
        const group = new DisplayGroupModel();
        group.name = name;
        this.displayGroupsService.createGroup(group).subscribe({
            next: (id: number) => {
                group.id = id;
                this.closeDialog(group);
            }
        });
    }

    cancel() {
        this.dialogCancelled.emit();
        this.coreDialogService.close(this.key);
    }

    ok() {
        this.closeDialog(this.selectedOption);
    }
}
